<template>
	<b-container fluid class="mt-3 mb-5">
		<b-row>
			<b-col cols="12" sm="6" xl="2" lg="3" md="4" v-bind:key="data.index" v-for="data in give">
				<b-card no-body class="mb-3">
					<b-link :href="'https://give543.com/give/'+data.id" target="_blank">
						<b-img-lazy :src="data.image_path" v-bind:img-alt="data.title" fluid blank-height="200" :center="true"></b-img-lazy>
					</b-link>
					<b-card-body>
						<b-card-title title-tag="h5">{{data.title}}</b-card-title>
						<b-card-text class="text-muted">{{data.desc}} -
							<b-link :href="'https://give543.com/user/'+data.user_id" target="_blank">{{data.user.nickname}}</b-link>
						</b-card-text>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<b-navbar type="light" variant="white" fixed="bottom" class="p-0">
			<b-navbar-nav justified class="w-100">
				<b-nav-item @click="addMore" class="">&ctdot;</b-nav-item>
				<b-nav-item @click="resetList" class="">&#10227;</b-nav-item>
			</b-navbar-nav>
		</b-navbar>
	</b-container>
</template>

<script>
  import axios from 'axios';
import { setTimeout } from 'timers';
  export default {
    data() {
    	return {
			page: 1,
			give: []
      };
    },
    methods: {
		getItem(){
    		axios.get('api.php',{
				params: {
					page: this.page++,
				}
			})
			.then(response => {
				this.give = this.give.concat(response.data.data)
			})
			.catch(err => {
				console.log(err);
			});
		},
		addMore(){
			this.getItem()
		},
		resetList(){
			this.page = 1
			this.give = []
			this.getItem()
		}
	},
	mounted() {
		this.getItem()
	},
	watch: {
		give: function(){
			setTimeout(() => window.scrollBy({
				top: window.innerHeight,
				behavior: 'smooth',
			}),1000)
		}
	}
  };
</script>